import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SignProcessEditingService {

    processIdBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
    processIdBehaviorSubjectObservable$ = this.processIdBehaviorSubject.asObservable();

    updateProcessId(processId: string): void {
        this.processIdBehaviorSubject.next(processId);
    }

  constructor() { }
}
